import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";
import * as secConverter from "hh-mm-ss";
import { Box, } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import { Table, TBody, Th, Tr, Td } from "@twilio/flex-ui/node_modules/@twilio-paste/core";

export class AgentStatistics extends React.Component {
    constructor(props) {
        super(props);
        var savedFilter = uhaulStore.getState().UhaulReducer.currentSelectedCategory;
        this.state = {
            serviceBaseUrl: uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl,
            selectedCategory: (savedFilter != null && savedFilter.selectedCategory != null)
                 ? savedFilter.selectedCategory
                 : "Other",
            allCategories: [],
            hasBeenMoved: false,
            chosenFilter: document.getElementById("agentFilters"),
            teamsView: document.getElementsByClassName("Twilio-WorkersDataTable")
        }
    }

    state = this.getCurrentStateFromStore();

    getCurrentStateFromStore() {
        return {
            config: uhaulStore.getState().UhaulReducer.config,
            supervisorStatistics: uhaulStore.getState().UhaulReducer.supervisorStatistics,
            taskQueueCategories: uhaulStore.getState().UhaulReducer.taskQueueCategories,
            currentSelectedCategory: uhaulStore.getState().UhaulReducer.currentSelectedCategory,
            teamsView: uhaulStore.getState().FlexReducer.teamsView,
            currentTaskContext: uhaulStore.getState().UhaulReducer.currentTaskContext,
            allQueues: uhaulStore.getState().UhaulReducer.allQueues
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();
        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    componentDidMount() {
        this.unsubscribeStore = uhaulStore.subscribe(this.updateStateFromStore);
    }

    componentWillUnmount() {
        this.unsubscribeStore();
    }


    render() {
        try
        {
            const customerServiceQueues = [
                "UBOX",
                "GENERAL-QUESTIONS",
                "SELF-STORAGE",
                "RENTAL-EQUIPMENT",
                "RETAIL-SALES",
                "TEST-QUEUE",
                "MOVING-HELP",
                "E-MOBILE-PICK-UP",
                "TRUCKSHARE 24/7 CUSTOMER CHAT",
                "OUTSTANDING-BALANCE"
            ];

            const taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext;
            const allQueues = uhaulStore.getState().UhaulReducer.allQueues;

            let taskQueueName = null;
            if (taskContexts._task && taskContexts._task.queueName){
                taskQueueName = taskContexts._task.queueName;
            }
            let contextQueueName = null;
            if (taskContexts.queueName){
                contextQueueName = taskContexts.queueName;
            }

            const queueMatch = allQueues && allQueues.length > 0 ? allQueues.find(queueItem => 
                queueItem.Name.toLowerCase().trim() === 
                (taskQueueName ? taskQueueName.toLowerCase().trim() : '')
              ) : "";

            const contextQueueMatch = allQueues && allQueues.length > 0 ? allQueues.find(queueItem => 
                queueItem.Name.toLowerCase().trim() === 
                (contextQueueName ? contextQueueName.toLowerCase().trim() : '')
              ) : "";

            /* Shows only for Customer Service queues */
            const taskQueueMatch = taskContexts && taskContexts._task && taskContexts._task.queueName
                              && customerServiceQueues.find(x => x === (queueMatch && queueMatch.Type ? queueMatch.Type.toUpperCase() : ''));
            const taskContextMatch = taskContexts && taskContexts.queueName
                              && customerServiceQueues.find(x => x === (contextQueueMatch && contextQueueMatch.Type ? contextQueueMatch.Type.toUpperCase(): ''));

            if (!(taskQueueMatch || taskContextMatch)) {
                return null;
            }

            const allQueuesStats = uhaulStore.getState().UhaulReducer.supervisorStatistics;
            if(!allQueuesStats) {
                return (<div className="waitingAgentStats">Waiting...</div>)
            }

            /* Shows only queues that the users are in*/
            const worker = uhaulStore.getState().UhaulReducer.currentUser != null ? uhaulStore.getState().UhaulReducer.currentUser : null;
            let relevantQueueStats = allQueuesStats;

            try
            {
                if(worker?.queues && allQueuesStats.length > 0)
                {
                    relevantQueueStats = allQueuesStats.filter(x => x.FriendlyName && (worker.queues.includes(x.FriendlyName.toLowerCase())));
                    if(worker.queues.includes("e-mobile-pick-up"))
                    {            
                        const foundQueue = allQueuesStats.filter(x => x.FriendlyName.toLowerCase() === "truck share");
                        if(foundQueue && foundQueue.length > 0)
                        {
                            relevantQueueStats.push(foundQueue[0]);
                        }
                    }
                }
            }
            catch(err)
            {
                console.error("error found with the agent queue stats", err)
            }
            
            if (relevantQueueStats.length === 0) {
                return (<div className="loadingAgentStats">Loading Queues...</div>)
            }

            return (
                <Box as="div" className="loadedAllAgentTaskStats">
                    <Table  className="loadedAllTaskStats">
                        <TBody>
                            <Tr>
                                <Th>Queues</Th>
                                <Th># of Chats Waiting</Th>
                                <Th>Longest Wait Time</Th>
                            </Tr>
                            {relevantQueueStats.map(function (thisTaskQueue_Stats) {
                                var longestWait = thisTaskQueue_Stats.Realtime.longest_task_waiting_age;
                                var longestWaitTime = longestWait != null && longestWait > 0
                                    ? secConverter.fromS(longestWait, "hh:mm:ss")
                                    : 0;
                                return <Tr key={thisTaskQueue_Stats.sid}>
                                    <Td>{thisTaskQueue_Stats.FriendlyName}</Td>
                                    <Td>{thisTaskQueue_Stats.Realtime.tasks_by_status.pending}</Td>
                                    <Td key={thisTaskQueue_Stats.Realtime.longest_task_waiting_sid}>
                                        {longestWaitTime}
                                    </Td>
                                </Tr>
                            }, this)}
                        </TBody>
                    </Table>
                </Box>);
        }
        catch(e)
        {
            console.error("error", e)
            return null;
        }
    }
}
